import { Form, Input, Select } from 'antd';
import React from 'react';
const validator = require('validator');

export default function SingleEmailComponent({ fieldProps, ...props }) {
	const emailValidator = (rule, value, callback) => {
		if (!value) {
			callback();
		}

		if (validator.isEmail(value)) {
			callback();
		} else {
			callback(value + ' is not a valid email');
		}
	};
	return (
		<Form.Item
			{...fieldProps}
			rules={[...(fieldProps.rules || []), { validator: emailValidator }, { required: true }]}
		>
			<Input placeholder="Enter emails" {...props} />
		</Form.Item>
	);
}
